import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BxHorizontalNavigationComponent } from '@core/components/navigation/horizontal/horizontal.component';
import { BxNavigationService } from '@core/components/navigation/navigation.service';
import { CBNavigationItem } from '@core/components/navigation/navigation.types';

@Component({
    selector       : 'cb-horizontal-navigation-spacer-item',
    templateUrl    : './spacer.component.html',
    styles         : [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BxHorizontalNavigationSpacerItemComponent implements OnInit, OnDestroy
{
    @Input() item: CBNavigationItem;
    @Input() name: string;

    private _bxHorizontalNavigationComponent: BxHorizontalNavigationComponent;
    private _unsubscribeSpcr: Subject<void> = new Subject();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _bxNavigationService: BxNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._bxHorizontalNavigationComponent = this._bxNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._bxHorizontalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeSpcr)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeSpcr.next();
        this._unsubscribeSpcr.complete();
    }
}
